import jump from 'jump.js';

class SmoothScroll {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="SmoothScroll"]'),
      header: document.querySelector('[data-module="Header"]'),
      ...options
    };
  }

  init() {
    const { moduleList, header } = this.config;

    moduleList.forEach(module => {
      module.addEventListener('click', e => {
        e.preventDefault();

        const id = module.getAttribute('href');
        const target = document.querySelector(id);
        const headerOffset = header ? header.getBoundingClientRect().height : 0;

        if (!target) {
          return;
        }

        jump(target, {
          duration: 500,
          offset: -(headerOffset + 50)
        });
      });
    });
  }
}

export default SmoothScroll;
